import { render } from "./BaseParticipantCard.vue?vue&type=template&id=99dd89de&scoped=true"
import script from "./BaseParticipantCard.vue?vue&type=script&lang=js"
export * from "./BaseParticipantCard.vue?vue&type=script&lang=js"

import "./BaseParticipantCard.vue?vue&type=style&index=0&id=99dd89de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99dd89de"]])

export default __exports__